<template>
  <li :class="`${carbonPrefix}--side-nav__divider`" />
</template>

<script setup>
import { carbonPrefix } from '../../global/settings';
</script>
